<template>
  <b-menu>
    <b-menu-list>
      <router-link to="/" tag="p">
        <span
          class="is-size-3 has-text-weight-bold has-text-primary"
          style="cursor: pointer"
        >
          Sortdesk
        </span>
      </router-link>
      <hr />
    </b-menu-list>
    <b-menu-list label="Dokumente">
      <b-menu-item
        icon="upload"
        tag="router-link"
        :to="{ name: 'DocumentUpload' }"
        label="Hochladen"
      ></b-menu-item>
      <b-menu-item
        icon="view-list"
        tag="router-link"
        :to="{ name: 'DocumentList' }"
        label="Liste"
      ></b-menu-item>
    </b-menu-list>
    <hr />
    <b-menu-list label="Über Sortdesk">
      <b-menu-item
        label="Die Idee"
        icon="information-outline"
        tag="router-link"
        :to="{ name: 'Idea' }"
      ></b-menu-item>
      <b-menu-item
        label="Problem"
        icon="tooltip-remove"
        tag="router-link"
        :to="{ name: 'Problem' }"
      ></b-menu-item>
      <b-menu-item
        label="Lösung"
        icon="sprout"
        tag="router-link"
        :to="{ name: 'Solution' }"
      ></b-menu-item>
      <b-menu-item
        label="Nächste Schritte"
        icon="rocket"
        tag="router-link"
        :to="{ name: 'NextStepsAndTechnical' }"
      ></b-menu-item>
    </b-menu-list>
    <hr />
    <b-menu-list label="Konto">
      <b-menu-item
        label="Ausloggen"
        icon="logout"
        @click="logout"
      ></b-menu-item>
    </b-menu-list>
  </b-menu>
</template>

<script>
import { logout } from "@/auth";

export default {
  data() {
    return {
      isActive: true
    };
  },
  methods: {
    logout() {
      logout();
      this.$router.go();
    }
  }
};
</script>
